module.exports = __webpack_public_path__ + "img/signature.f580bceb.png";